"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMediaConversion = exports.isExistingMediaFile = exports.MediaQuality = exports.MediaType = void 0;
const environments_1 = require("./environments");
var MediaType;
(function (MediaType) {
    MediaType["image"] = "image";
    MediaType["video"] = "video";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var MediaQuality;
(function (MediaQuality) {
    MediaQuality["hq"] = "hq";
    MediaQuality["uhd"] = "uhd";
})(MediaQuality = exports.MediaQuality || (exports.MediaQuality = {}));
/** Typeguard for convertMedia return value */
exports.isExistingMediaFile = (obj) => obj.key;
/** Typeguard for convertMedia return value */
exports.isMediaConversion = (obj) => obj.transcodedFileKey;
//# sourceMappingURL=media.js.map